import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { IrisProjectSelectEngine, FilterProjectsBy } from './project-select.engine';
import { PROJECT_SELECT_PROVIDERS } from './project-select.providers';

@Directive({
  selector: 'sk-select[iris-entity=project]',
  providers: PROJECT_SELECT_PROVIDERS,
})
export class IrisProjectSkSelectDirective implements OnChanges {
  private readonly engine = inject(IrisProjectSelectEngine);

  readonly searchOnlyInProjects = input<number[]>(undefined);
  readonly showCostCenter = input<boolean>();
  readonly excludeProjectIds = input<number[]>();
  readonly hideRecentProjects = input<boolean>();
  readonly includeInactiveProjects = input<boolean>();
  readonly filterBy = input<FilterProjectsBy>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchOnlyInProjects) {
      this.engine.searchOnlyInProjects(changes.searchOnlyInProjects.currentValue);
    }

    if (changes.showCostCenter) {
      this.engine.options.showCostCenter = coerceBooleanProperty(changes.showCostCenter.currentValue);
    }

    if (changes.hideRecentProjects) {
      this.engine.options.hideRecentProjects = coerceBooleanProperty(changes.hideRecentProjects.currentValue);
    }

    if (changes.includeInactiveProjects) {
      this.engine.setIncludeInactiveProjects(coerceBooleanProperty(changes.includeInactiveProjects.currentValue));
    }

    if (changes.excludeProjectIds) {
      this.engine.excludeProjects(changes.excludeProjectIds.currentValue);
    }

    if (changes.filterBy) {
      this.engine.searchOnlyInProjectsWith(changes.filterBy.currentValue);
    }
  }
}
